/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable import/prefer-default-export */
import api from '@utils/axios';
import { apiInternalNotePath, apiInternalNotesPath } from '../../../routes';
export const updateNote = ({ id, note }) => {
    const body = new FormData();
    body.append('building_note[notes]', note.notes);
    body.append('building_note[visibility]', note.visibility);
    return api.put(apiInternalNotePath(id, { id, format: 'json', _options: true }), body);
};
export const deleteNote = ({ id }) => api.delete(apiInternalNotePath(id, { id, format: 'json', _options: true }));
export const createNote = ({ buildingId, inspectionId, invoiceId, workOrderId, deficiencyId, proposalId, notes, visibility }) => {
    const body = new FormData();
    body.append('building_note[notes]', notes);
    body.append('building_note[visibility]', visibility);
    return api.post(apiInternalNotesPath({
        building_id: buildingId,
        inspection_id: inspectionId,
        invoice_id: invoiceId,
        work_order_id: workOrderId,
        deficiency_id: deficiencyId,
        proposal_id: proposalId,
        format: 'json'
    }), body);
};
